import React from 'react';
import PropTypes from "prop-types";
import Circle from "./Circle";

const Points = (props) => {
    return (
            <g id="points" transform={`translate(${props.x}, ${props.y})`}>
                <circle fill="#fff" cx="398.9" cy="31.2" r="1.2"/>
                <circle fill="#fff" cx="388.1" cy="31.3" r="1.2"/>
                <circle fill="#fff" cx="377.3" cy="31.9" r="1.2"/>
                <circle fill="#fff" cx="366.5" cy="32.9" r="1.2"/>
                <circle fill="#fff" cx="355.8" cy="34.2" r="1.2"/>
                <circle fill="#fff" cx="345.1" cy="35.9" r="1.2"/>
                <circle fill="#fff" cx="334.5" cy="37.9" r="1.2"/>
                <circle fill="#fff" cx="324" cy="40.3" r="1.2"/>
                <circle fill="#fff" cx="313.6" cy="43.1" r="1.2"/>
                <circle fill="#fff" cx="303.2" cy="46.3" r="1.2"/>
                <circle fill="#fff" cx="293" cy="49.8" r="1.2"/>
                <circle fill="#fff" cx="282.9" cy="53.7" r="1.2"/>
                <circle fill="#fff" cx="273" cy="57.9" r="1.2"/>
                <circle fill="#fff" cx="263.2" cy="62.5" r="1.2"/>
                <circle fill="#fff" cx="253.5" cy="67.4" r="1.2"/>
                <circle fill="#fff" cx="244.1" cy="72.6" r="1.2"/>
                <circle fill="#fff" cx="234.8" cy="78.2" r="1.2"/>
                <circle fill="#fff" cx="225.7" cy="84.1" r="1.2"/>
                <circle fill="#fff" cx="216.9" cy="90.3" r="1.2"/>
                <circle fill="#fff" cx="208.3" cy="96.8" r="1.2"/>
                <circle fill="#fff" cx="199.9" cy="103.6" r="1.2"/>
                <circle fill="#fff" cx="191.7" cy="110.7" r="1.2"/>
                <circle fill="#fff" cx="183.8" cy="118" r="1.2"/>
                <circle fill="#fff" cx="176.2" cy="125.7" r="1.2"/>
                <circle fill="#fff" cx="168.8" cy="133.6" r="1.2"/>
                <circle fill="#fff" cx="161.7" cy="141.7" r="1.2"/>
                <circle fill="#fff" cx="154.9" cy="150.1" r="1.2"/>
                <circle fill="#fff" cx="148.4" cy="158.8" r="1.2"/>
                <circle fill="#fff" cx="142.2" cy="167.6" r="1.2"/>
                <circle fill="#fff" cx="136.3" cy="176.7" r="1.2"/>
                <circle fill="#fff" cx="130.7" cy="185.9" r="1.2"/>
                <circle fill="#fff" cx="125.5" cy="195.4" r="1.2"/>
                <circle fill="#fff" cx="120.6" cy="205" r="1.2"/>
                <circle fill="#fff" cx="116" cy="214.8" r="1.2"/>
                <circle fill="#fff" cx="111.8" cy="224.8" r="1.2"/>
                <circle fill="#fff" cx="107.9" cy="234.8" r="1.2"/>
                <circle fill="#fff" cx="104.4" cy="245.1" r="1.2"/>
                <circle fill="#fff" cx="101.2" cy="255.4" r="1.2"/>
                <circle fill="#fff" cx="98.4" cy="265.8" r="1.2"/>
                <circle fill="#fff" cx="96" cy="276.4" r="1.2"/>
                <circle fill="#fff" cx="93.9" cy="287" r="1.2"/>
                <circle fill="#fff" cx="92.2" cy="297.6" r="1.2"/>
                <circle fill="#fff" cx="90.9" cy="308.4" r="1.2"/>
                <circle fill="#fff" cx="90" cy="319.1" r="1.2"/>
                <circle fill="#fff" cx="89.4" cy="329.9" r="1.2"/>
                <circle fill="#fff" cx="89.2" cy="340.7" r="1.2"/>
                <circle fill="#fff" cx="89.4" cy="351.5" r="1.2"/>
                <circle fill="#fff" cx="90" cy="362.3" r="1.2"/>
                <circle fill="#fff" cx="90.9" cy="373.1" r="1.2"/>
                <circle fill="#fff" cx="92.2" cy="383.8" r="1.2"/>
                <circle fill="#fff" cx="93.9" cy="394.5" r="1.2"/>
                <circle fill="#fff" cx="96" cy="405.1" r="1.2"/>
                <circle fill="#fff" cx="98.4" cy="415.6" r="1.2"/>
                <circle fill="#fff" cx="101.2" cy="426.1" r="1.2"/>
                <circle fill="#fff" cx="104.4" cy="436.4" r="1.2"/>
                <circle fill="#fff" cx="107.9" cy="446.6" r="1.2"/>
                <circle fill="#fff" cx="111.7" cy="456.7" r="1.2"/>
                <circle fill="#fff" cx="116" cy="466.7" r="1.2"/>
                <circle fill="#fff" cx="120.5" cy="476.5" r="1.2"/>
                <circle fill="#fff" cx="125.4" cy="486.1" r="1.2"/>
                <circle fill="#fff" cx="130.7" cy="495.6" r="1.2"/>
                <circle fill="#fff" cx="136.2" cy="504.8" r="1.2"/>
                <circle fill="#fff" cx="142.1" cy="513.9" r="1.2"/>
                <circle fill="#fff" cx="148.3" cy="522.7" r="1.2"/>
                <circle fill="#fff" cx="154.8" cy="531.4" r="1.2"/>
                <circle fill="#fff" cx="161.6" cy="539.8" r="1.2"/>
                <circle fill="#fff" cx="168.7" cy="547.9" r="1.2"/>
                <circle fill="#fff" cx="176.1" cy="555.8" r="1.2"/>
                <circle fill="#fff" cx="183.7" cy="563.5" r="1.2"/>
                <circle fill="#fff" cx="191.6" cy="570.9" r="1.2"/>
                <circle fill="#fff" cx="199.8" cy="578" r="1.2"/>
                <circle fill="#fff" cx="208.2" cy="584.8" r="1.2"/>
                <circle fill="#fff" cx="217.2" cy="590.8" r="1.2"/>
                <circle fill="#fff" cx="225.7" cy="597.5" r="1.2"/>
                <circle fill="#fff" cx="234.7" cy="603.4" r="1.2"/>
                <circle fill="#fff" cx="244" cy="608.9" r="1.2"/>
                <circle fill="#fff" cx="253.4" cy="614.2" r="1.2"/>
                <circle fill="#fff" cx="263.1" cy="619.1" r="1.2"/>
                <circle fill="#fff" cx="272.9" cy="623.6" r="1.2"/>
                <circle fill="#fff" cx="282.8" cy="627.9" r="1.2"/>
                <circle fill="#fff" cx="292.9" cy="631.7" r="1.2"/>
                <circle fill="#fff" cx="303.1" cy="635.3" r="1.2"/>
                <circle fill="#fff" cx="313.4" cy="638.4" r="1.2"/>
                <circle fill="#fff" cx="323.9" cy="641.2" r="1.2"/>
                <circle fill="#fff" cx="334.4" cy="643.6" r="1.2"/>
                <circle fill="#fff" cx="345" cy="645.7" r="1.2"/>
                <circle fill="#fff" cx="355.7" cy="647.4" r="1.2"/>
                <circle fill="#fff" cx="366.4" cy="648.7" r="1.2"/>
                <circle fill="#fff" cx="377.2" cy="649.7" r="1.2"/>
                <circle fill="#fff" cx="388" cy="650.2" r="1.2"/>
                <circle fill="#fff" cx="398.8" cy="650.4" r="1.2"/>
                <circle fill="#fff" cx="409.6" cy="650.2" r="1.2"/>
                <circle fill="#fff" cx="420.4" cy="649.7" r="1.2"/>
                <circle fill="#fff" cx="431.2" cy="648.7" r="1.2"/>
                <circle fill="#fff" cx="441.9" cy="647.4" r="1.2"/>
                <circle fill="#fff" cx="452.6" cy="645.7" r="1.2"/>
                <circle fill="#fff" cx="463.2" cy="643.7" r="1.2"/>
                <circle fill="#fff" cx="473.7" cy="641.2" r="1.2"/>
                <circle fill="#fff" cx="484.1" cy="638.4" r="1.2"/>
                <circle fill="#fff" cx="494.5" cy="635.3" r="1.2"/>
                <circle fill="#fff" cx="504.7" cy="631.8" r="1.2"/>
                <circle fill="#fff" cx="514.8" cy="627.9" r="1.2"/>
                <circle fill="#fff" cx="524.7" cy="623.7" r="1.2"/>
                <circle fill="#fff" cx="534.5" cy="619.1" r="1.2"/>
                <circle fill="#fff" cx="544.2" cy="614.2" r="1.2"/>
                <circle fill="#fff" cx="553.6" cy="609" r="1.2"/>
                <circle fill="#fff" cx="562.9" cy="603.4" r="1.2"/>
                <circle fill="#fff" cx="571.9" cy="597.5" r="1.2"/>
                <circle fill="#fff" cx="580.6" cy="591.2" r="1.2"/>
                <circle fill="#fff" cx="589.4" cy="584.8" r="1.2"/>
                <circle fill="#fff" cx="597.8" cy="578" r="1.2"/>
                <circle fill="#fff" cx="606" cy="570.9" r="1.2"/>
                <circle fill="#fff" cx="613.9" cy="563.6" r="1.2"/>
                <circle fill="#fff" cx="621.5" cy="555.9" r="1.2"/>
                <circle fill="#fff" cx="628.9" cy="548" r="1.2"/>
                <circle fill="#fff" cx="636" cy="539.9" r="1.2"/>
                <circle fill="#fff" cx="642.8" cy="531.5" r="1.2"/>
                <circle fill="#fff" cx="649.3" cy="522.8" r="1.2"/>
                <circle fill="#fff" cx="655.5" cy="514" r="1.2"/>
                <circle fill="#fff" cx="661.4" cy="504.9" r="1.2"/>
                <circle fill="#fff" cx="667" cy="495.7" r="1.2"/>
                <circle fill="#fff" cx="672.2" cy="486.2" r="1.2"/>
                <circle fill="#fff" cx="677.1" cy="476.6" r="1.2"/>
                <circle fill="#fff" cx="681.7" cy="466.8" r="1.2"/>
                <circle fill="#fff" cx="685.9" cy="456.8" r="1.2"/>
                <circle fill="#fff" cx="689.8" cy="446.7" r="1.2"/>
                <circle fill="#fff" cx="693.3" cy="436.5" r="1.2"/>
                <circle fill="#fff" cx="696.5" cy="426.2" r="1.2"/>
                <circle fill="#fff" cx="699.3" cy="415.8" r="1.2"/>
                <circle fill="#fff" cx="701.7" cy="405.2" r="1.2"/>
                <circle fill="#fff" cx="703.8" cy="394.6" r="1.2"/>
                <circle fill="#fff" cx="705.5" cy="383.9" r="1.2"/>
                <circle fill="#fff" cx="706.8" cy="373.2" r="1.2"/>
                <circle fill="#fff" cx="707.7" cy="362.4" r="1.2"/>
                <circle fill="#fff" cx="708.3" cy="351.7" r="1.2"/>
                <circle fill="#fff" cx="708.5" cy="340.8" r="1.2"/>
                <circle fill="#fff" cx="708.3" cy="330" r="1.2"/>
                <circle fill="#fff" cx="707.7" cy="319.3" r="1.2"/>
                <circle fill="#fff" cx="706.8" cy="308.5" r="1.2"/>
                <circle fill="#fff" cx="705.5" cy="297.8" r="1.2"/>
                <circle fill="#fff" cx="703.8" cy="287.1" r="1.2"/>
                <circle fill="#fff" cx="701.7" cy="276.5" r="1.2"/>
                <circle fill="#fff" cx="699.3" cy="265.9" r="1.2"/>
                <circle fill="#fff" cx="696.5" cy="255.5" r="1.2"/>
                <circle fill="#fff" cx="693.3" cy="245.2" r="1.2"/>
                <circle fill="#fff" cx="689.8" cy="234.9" r="1.2"/>
                <circle fill="#fff" cx="686" cy="224.9" r="1.2"/>
                <circle fill="#fff" cx="681.7" cy="214.9" r="1.2"/>
                <circle fill="#fff" cx="677.2" cy="205.1" r="1.2"/>
                <circle fill="#fff" cx="672.3" cy="195.5" r="1.2"/>
                <circle fill="#fff" cx="667" cy="186" r="1.2"/>
                <circle fill="#fff" cx="661.5" cy="176.8" r="1.2"/>
                <circle fill="#fff" cx="655.6" cy="167.7" r="1.2"/>
                <circle fill="#fff" cx="649.4" cy="158.8" r="1.2"/>
                <circle fill="#fff" cx="642.9" cy="150.2" r="1.2"/>
                <circle fill="#fff" cx="636.1" cy="141.8" r="1.2"/>
                <circle fill="#fff" cx="629" cy="133.6" r="1.2"/>
                <circle fill="#fff" cx="621.6" cy="125.7" r="1.2"/>
                <circle fill="#fff" cx="614" cy="118.1" r="1.2"/>
                <circle fill="#fff" cx="606.1" cy="110.7" r="1.2"/>
                <circle fill="#fff" cx="597.9" cy="103.6" r="1.2"/>
                <circle fill="#fff" cx="589.5" cy="96.8" r="1.2"/>
                <circle fill="#fff" cx="580.9" cy="90.3" r="1.2"/>
                <circle fill="#fff" cx="572" cy="84.1" r="1.2"/>
                <circle fill="#fff" cx="563" cy="78.2" r="1.2"/>
                <circle fill="#fff" cx="553.7" cy="72.7" r="1.2"/>
                <circle fill="#fff" cx="544.3" cy="67.4" r="1.2"/>
                <circle fill="#fff" cx="534.6" cy="62.5" r="1.2"/>
                <circle fill="#fff" cx="524.8" cy="58" r="1.2"/>
                <circle fill="#fff" cx="514.9" cy="53.7" r="1.2"/>
                <circle fill="#fff" cx="504.8" cy="49.9" r="1.2"/>
                <circle fill="#fff" cx="494.6" cy="46.3" r="1.2"/>
                <circle fill="#fff" cx="484.2" cy="43.2" r="1.2"/>
                <circle fill="#fff" cx="473.8" cy="40.4" r="1.2"/>
                <circle fill="#fff" cx="463.3" cy="37.9" r="1.2"/>
                <circle fill="#fff" cx="452.7" cy="35.9" r="1.2"/>
                <circle fill="#fff" cx="442" cy="34.2" r="1.2"/>
                <circle fill="#fff" cx="431.3" cy="32.9" r="1.2"/>
                <circle fill="#fff" cx="420.5" cy="31.9" r="1.2"/>
                <circle fill="#fff" cx="409.7" cy="31.4" r="1.2"/>
                <circle fill="#fff" cx="398.9" cy="31.2" r="1.2"/>
            </g>
    );
};

export default Points;

Circle.defaultProps = {
    x: 0,
    y: 0,
};

Circle.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
};


// WEBPACK FOOTER //
// ./sources/js/components/Question/graph/Points.js